var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/SelectPlayerFollows/index.js";
var _excluded = ["className", "containerProps", "env", "followLabel", "followingLabel", "followedPlayers", "teamId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import axios from "axios";
import React, { useEffect, useState } from "react";
import { DEFAULT_ENV, ENV_CONFIG, minifyQuery } from "../FieldPass/utils";
import ListContainer, { ListContainerTypes } from "../ListContainer";
import Spinner from "../Spinner";
import { GET_ROSTER } from "./query";
import { SelectPlayerFollowsContainer } from "./styles";
import { normalizeRoster } from "./utils";
var ComponentKey = "select-player-follows";
var SelectPlayerFollows = function SelectPlayerFollows(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    _ref$env = _ref.env,
    env = _ref$env === void 0 ? DEFAULT_ENV : _ref$env,
    _ref$followLabel = _ref.followLabel,
    followLabel = _ref$followLabel === void 0 ? "FOLLOW" : _ref$followLabel,
    _ref$followingLabel = _ref.followingLabel,
    followingLabel = _ref$followingLabel === void 0 ? "FOLLOWING" : _ref$followingLabel,
    followedPlayers = _ref.followedPlayers,
    teamId = _ref.teamId,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!teamId) {
    // eslint-disable-next-line
    console.error("❌ [SelectPlayerFollows] prop `teamId` is required");
    return null;
  }
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    roster = _useState2[0],
    setRoster = _useState2[1];
  useEffect(function () {
    var controller = new AbortController();
    function getRoster() {
      return _getRoster.apply(this, arguments);
    }
    function _getRoster() {
      _getRoster = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _res$data, _res$data$data, _res$data$data$team, _ref2, midfield, query, variables, res, _ref3, _roster;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Reset in case subsequent request fails
                setRoster(null);
                _context.prev = 1;
                _ref2 = ENV_CONFIG[env] || ENV_CONFIG[DEFAULT_ENV], midfield = _ref2.midfield;
                query = "?query=".concat(minifyQuery(GET_ROSTER));
                variables = "&variables=".concat(JSON.stringify({
                  ids: [parseInt(teamId, 10)]
                }));
                _context.next = 7;
                return axios.get("".concat(midfield).concat(query).concat(variables), {
                  headers: {
                    "apollo-require-preflight": true,
                    "apollographql-client-name": "publishing-services/account-components"
                  },
                  signal: controller.signal
                });
              case 7:
                res = _context.sent;
                _ref3 = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : (_res$data$data = _res$data.data) === null || _res$data$data === void 0 ? void 0 : (_res$data$data$team = _res$data$data.team) === null || _res$data$data$team === void 0 ? void 0 : _res$data$data$team[0]) || {}, _roster = _ref3.roster;
                if (_roster) {
                  setRoster(_roster);
                }
                _context.next = 15;
                break;
              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);
                if (!axios.isCancel(_context.t0)) {
                  // eslint-disable-next-line
                  console.error("[SelectPlayerFollows] getRoster request failed: ".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message));
                }
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 12]]);
      }));
      return _getRoster.apply(this, arguments);
    }
    getRoster();
    return function () {
      return controller.abort();
    };
  }, [teamId]);
  var items = normalizeRoster({
    followLabel: followLabel,
    followingLabel: followingLabel,
    followedPlayers: followedPlayers,
    roster: roster
  });
  return /*#__PURE__*/React.createElement(SelectPlayerFollowsContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 74,
      columnNumber: 5
    }
  }), !roster ? /*#__PURE__*/React.createElement(Spinner, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(ListContainer, _extends({
    items: items,
    type: ListContainerTypes.FOLLOW
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 9
    }
  })));
};
export default /*#__PURE__*/React.memo(SelectPlayerFollows);